var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUsers = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.078431 0 0 0 0 0.262745 0 0 0 0 0.658824 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#prefix__a)",
    transform: "translate(1 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#A7B9DB",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12c-2.824 0-5.329.638-6.975 1.193C.81 13.604 0 14.749 0 16.032V20h8",
    transform: "translate(0 10)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M9 12h0c-2.761 0-5-3.239-5-6V5c0-2.761 2.239-5 5-5h0c2.761 0 5 2.239 5 5v1c0 2.761-2.239 6-5 6zM15 22L12 22 12 19 18 13 21 16z",
    transform: "translate(0 10)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/users.0d6e6d43.svg";
export { ForwardRef as ReactComponent };